import React from 'react';
import { FieldHookConfig, useField, useFormikContext } from 'formik';
import { SxProps, Theme } from '@mui/material';
import { Select } from '@cnx-saas/common-fe';

interface SelectProps<T> {
  label: string;
  error?: boolean;
  errorMessage?: string;
  required?: boolean;
  options: {
    value: T;
    label: React.ReactNode;
  }[];
  style?: SxProps<Theme> | undefined;
}

type SelectFieldProps<T> = SelectProps<T> & FieldHookConfig<T>;

function SelectField<T extends string>(
  props: SelectFieldProps<T>,
): JSX.Element {
  const { setFieldValue } = useFormikContext();
  const [field] = useField(props);
  // TODO _error, _errorMessage,
  const { label, required, options, error, errorMessage, style } = props;

  const selectedOption = options.find(({ value }) => value === field.value);

  return (
    <Select
      label={label}
      options={options}
      selectedOption={selectedOption}
      onSingleSelect={(option) => setFieldValue(field.name, option.value)}
      isRequired={required}
      error={error}
      errorMessage={errorMessage}
      sx={style}
    />
  );
}

export type { SelectFieldProps };
export { SelectField };
